import { faSmile } from '@fortawesome/pro-regular-svg-icons';
import { faCamera } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BLOGS_ADD_NEW_COMMENT_PLACEHOLDER, SEND_COMMENT_FORUM } from 'mk/autogenerated/translations/CommentAdd.8eff81c3cde37aafe6312fe40fd92171'
import { BlogPostCommentCreateFormFactory } from 'mk2/apps/blogs/components/BlogPostCommentCreateForm';
import { MessageFormFactory } from 'mk2/apps/blogs/components/MessageForm';
import { CommentsDesign } from 'mk2/apps/blogs/constants';
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import Sticker, { StickerSize } from 'mk2/components/Sticker';
import { UserEntity } from 'mk2/schemas';
import React, { useMemo } from 'react';
import styles from './CommentAdd.mscss';

interface OwnProps {
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    canAdd: boolean; // has add new comment form
    hasBlueToolbar?: boolean;
    showFakeTextareaIfCantAdd: boolean;
    createFormName: string;
    design: CommentsDesign;

    onSetTextareaRef?(ref: HTMLTextAreaElement);
    onCreate(commentFd: CommentFormData);
    onCreateUnauthenticated();
    onBlur?();
    onFocus?();
}

const CommentAdd: React.FunctionComponent<OwnProps> = ({
    canAdd,
    showFakeTextareaIfCantAdd,
    requestUser,
    requestUserPermissions,
    design,
    isMobile,
    hasBlueToolbar,
    createFormName,
    onBlur,
    onFocus,
    onCreate,
    onSetTextareaRef,
    onCreateUnauthenticated,
}) => {
    const BlogPostCommentCreateForm = useMemo(() => BlogPostCommentCreateFormFactory(createFormName), [createFormName]);
    const MessageForm = useMemo(() => MessageFormFactory(createFormName), [createFormName]);
    const initialValues: CommentFormData = useMemo(() => ({ text: '', photos: [], sticker: null }), [createFormName]);

    if (canAdd) {
        return design === CommentsDesign.Normal ? (
            <BlogPostCommentCreateForm
                initialValues={initialValues}
                isMobile={isMobile}
                hasBlueToolbar={hasBlueToolbar}
                onBlur={onBlur}
                onFocus={onFocus}
                onSave={onCreate}
                requestUserPermissions={requestUserPermissions}
                textareaRef={onSetTextareaRef}
            />
        ) : (
            <div className={styles.CommentAdd__messageForm}>
                <MessageForm
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    initialValues={initialValues}
                    onSend={onCreate}
                    textareaRef={onSetTextareaRef}
                />
            </div>
        );
    } else if (showFakeTextareaIfCantAdd) {
        return (
            <div className={styles.CommentAdd__fakeTextarea} onClick={onCreateUnauthenticated}>
                <p className={styles.CommentAdd__fakeTextarea__label}>{BLOGS_ADD_NEW_COMMENT_PLACEHOLDER}</p>
                <div className={styles.CommentAdd__fakeTextarea__footer}>
                    <div className={styles.CommentAdd__fakeTextarea__footer__fakeToolbar}>
                        <FontAwesomeIcon
                            icon={faSmile}
                            className={styles.CommentAdd__fakeTextarea__footer__fakeToolbar__icon}
                        />
                        <FontAwesomeIcon
                            icon={faCamera}
                            className={styles.CommentAdd__fakeTextarea__footer__fakeToolbar__icon}
                        />
                        <Sticker id={0} size={StickerSize.Icon} />
                    </div>
                    <div className={styles.CommentAdd__fakeTextarea__footer__fakeBtn}>
                        <div className={styles.CommentAdd__fakeTextarea__footer__fakeBtn__label}>
                            {SEND_COMMENT_FORUM}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

CommentAdd.displayName = 'CommentAdd';

export default React.memo<OwnProps>(CommentAdd);
